// extracted by mini-css-extract-plugin
export default {"straightLine":"FunctionListItem_straightLine__JaV8f"};